// @ts-nocheck
import { getValveOptions } from "@store/Framework/Services/ValveConfiguratorService";
import { OptionsResponseModel } from "@store/Framework/Types/ValveConfiguratorApiModels";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface LoadValveOptionsParameter {
    series: string;
    size: number;
}

export interface LoadValveOptionsResult {
    apiResult?: OptionsResponseModel;
}

type HandlerType = Handler<LoadValveOptionsParameter, LoadValveOptionsResult>;

export const DispatchBeginLoadOptions: HandlerType = props => {
    props.dispatch({ type: "Data/ValveConfigurator/BeginLoadOptions" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getValveOptions(props.parameter);
    } catch (error) {
        const message = error instanceof Error ? error.message : "Could not load options.";
        props.dispatch({ type: "Data/ValveConfigurator/FailLoadOptions", message });
        return false;
    }
};

export const DispatchCompleteLoadOptions: HandlerType = ({ dispatch, apiResult }) => {
    if (!apiResult) {
        return;
    }

    dispatch({ type: "Data/ValveConfigurator/CompleteLoadOptions", result: apiResult });
};

export const chain = [DispatchBeginLoadOptions, RequestDataFromApi, DispatchCompleteLoadOptions];

const loadValveOptions = createHandlerChainRunner(chain, "LoadValveOptions");
export default loadValveOptions;
